<template>
  <div class="plugin-shell-page">
    <HistoricalPlugIn :key="'history'" />
  </div>
</template>

<script>
import HistoricalPlugIn from '@/views/transportService/historicalPlugIn.vue'

export default {
  name: 'HistoryName',
  components: { HistoricalPlugIn }
}
</script>

<style scoped>
.plugin-shell-page {
  width: 100%;
  height: calc(100vh - 78px);
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}
</style>
